export class RekbotNoteStateService {
    private isEditing = false;

    setEditing(isEditing: boolean) {
        this.isEditing = isEditing;
    }
    getEditing() {
        const value = this.isEditing;
        this.isEditing = false; // resetowanie stanu po odczytaniu
        return value;
    }
} 